var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2447 11.2895C15.2447 12.8853 13.9601 14.1711 12.3851 14.1711C10.8101 14.1711 9.52551 12.8853 9.52551 11.2895C9.52551 9.69378 10.8101 8.40796 12.3851 8.40796C13.9601 8.40796 15.2447 9.69378 15.2447 11.2895Z",
    stroke: "#1579C1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9415 10.6705C20.0672 10.9304 20.13 11.0603 20.13 11.2894C20.13 11.5185 20.0672 11.6484 19.9415 11.9083C19.2512 13.3357 17.1107 16.7368 12.3851 16.7368C7.65948 16.7368 5.51893 13.3357 4.82867 11.9083C4.703 11.6484 4.64016 11.5185 4.64016 11.2894C4.64016 11.0603 4.703 10.9304 4.82867 10.6705C5.51893 9.24313 7.65949 5.84204 12.3851 5.84204C17.1107 5.84204 19.2512 9.24313 19.9415 10.6705Z",
    stroke: "#1579C1",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0026 1H20.0153C21.8067 1 22.7023 1 23.2588 1.5565C23.8153 2.11299 23.8153 3.00866 23.8153 4.8V5.8421",
    stroke: "#C1C8CD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0026 21.5789H20.0153C21.8067 21.5789 22.7023 21.5789 23.2588 21.0224C23.8153 20.4659 23.8153 19.5702 23.8153 17.7789V16.7368",
    stroke: "#C1C8CD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76746 1H4.75469C2.96335 1 2.06768 1 1.51119 1.5565C0.954688 2.11299 0.954688 3.00866 0.954688 4.8V5.8421",
    stroke: "#C1C8CD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76746 21.5789H4.75469C2.96335 21.5789 2.06768 21.5789 1.51119 21.0224C0.954688 20.4659 0.954688 19.5702 0.954688 17.7789V16.7368",
    stroke: "#C1C8CD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b61462f2321727c6e9c0fa4940114943.svg";
export { ForwardRef as ReactComponent };